import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppSettings } from 'src/app/app-settings';
import { EventosService } from 'src/app/services/eventos.service';
import { BondsServices } from 'src/app/services/bonds.service';
import { InfoAbonosComponent } from '../../bloques/info-abonos/info-abonos.component';
import { PrivateEventComponent } from '../../bloques/private-event/private-event.component';
import { TicketsBondComponent } from '../../bloques/tickets-bond/tickets-bond.component';
import { InfoCardComponent } from '../../shared/info-card/info-card.component';

@Component({
  selector: 'app-btns-event-totem',
  templateUrl: './btns-event-totem.component.html',
  styleUrls: ['./btns-event-totem.component.scss']
})
export class BtnsEventTotemComponent {

  @Input() event!: any;
  @Input() pastEvent!: boolean;
  @Input() repeat: any;
  @Output() openHours: EventEmitter<boolean> = new EventEmitter();
  disabledSales: boolean = true;
  endSales: boolean = false;
  enableAbono: boolean = false;
  optionsHour: any[] = [];

  viewTotem: boolean = AppSettings.ENV_TOTEM;

  constructor(private eventosService: EventosService, private dialog: MatDialog, private router: Router, private bondsService: BondsServices) {
  }

  ngOnInit(): void {
    this.checkEventHasAbono();
    let now = new Date();
    let nowHour = new Date();
    now.setHours(0);
    now.setMinutes(0);
    this.disabledSales = this.event?.start_sales && ((new Date(this.event?.start_sales) > nowHour));
    let hoursEvent = this.event.sessions.filter(session => session.active == true);
    this.optionsHour = hoursEvent.sort((a: any, b: any) => {
      return new Date(a.start_date).getTime() - new Date(b.start_date).getTime();
    })
    if (this.event?.end_sales) {
      this.endSales = (new Date(this.event?.end_sales) <= nowHour);
    } else {
      // No estará activa la venta si el evento ha empezado. Mirar la fecha fin del evento y la hora fin
      let enabledDates = this.event.sessions.filter((fecha: any) => fecha.active && (new Date(fecha.start_date) >= now));
      if (enabledDates?.length <= 0) {
        this.endSales = true;
      } else {
        let datesSort = enabledDates.sort((a, b) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime());
        let last = datesSort[datesSort.length - 1];
        if ((!last?.start_date && new Date(last?.start_date).getFullYear() == now.getFullYear() && new Date(last?.start_date).getMonth() == now.getMonth() && new Date(last?.start_date).getDate() == now.getDate())) {
          // Si la fecha Fin es igual al día actual, comprobar la hora
          let lastHour = this.optionsHour[this.optionsHour.length - 1];
          if (new Date(lastHour.start_date).getUTCHours() < nowHour.getHours()) {
            this.endSales = true;
          } else if (new Date(lastHour.start_date).getUTCHours() == nowHour.getHours() && new Date(lastHour.start_date).getUTCMinutes() <= nowHour.getMinutes()) {
            this.endSales = true;
          }
        }
      }
    }
    this.checkEventHasAbono();
  }

  buyAbono() {
    // Comprobar si es un evento privado
    if (this.event.private_event) {
      const refAbonosDialog = this.dialog.open(PrivateEventComponent, {
        panelClass: ['info-dialog', 'not-padding', 'info-abono-dialog'],
      });
      refAbonosDialog.afterClosed().subscribe({
        next: (result) => {
          if (result) {
            this.eventosService.checkCodePrivateEvent(this.event.id, result).subscribe({
              next: (data: any) => {
                if (data.success) {
                  this.openDialogBond();
                } else {
                  const dialogRef = this.dialog.open(InfoCardComponent, {
                    panelClass: 'info-dialog',
                    data: {
                      icon: true,
                      text: 'Lo sentimos, el código es incorrecto.',
                      btnCancel: false
                    }
                  });
                }
              }, error: (err) => {
                const dialogRef = this.dialog.open(InfoCardComponent, {
                  panelClass: 'info-dialog',
                  data: {
                    icon: true,
                    text: 'Lo sentimos, el código es incorrecto.',
                    btnCancel: false
                  }
                });
              }
            });
          }
        }
      })
    } else {
      this.openDialogBond();
    }
  }

  openTicketsBond() {
    let bondTicket = this.event?.tickets?.[0];
    const refAbonosDialog = this.dialog.open(TicketsBondComponent, {
      panelClass: ['info-dialog', 'not-padding'],
      data: { ticket: bondTicket, eventId: this.event.id, eventName: this.event.title }
    });
    refAbonosDialog.afterClosed().subscribe({
      next: (result) => {
        if (result) {
          this.router.navigate(['/cart-checkout']);
        }
      }
    })
  }

  openDialogBond() {
    const refAbonosDialog = this.dialog.open(InfoAbonosComponent, {
      panelClass: ['info-dialog', 'not-padding', 'info-abono-dialog'],
      data: { event: this.event, hasAbono: true, sessions: this.event.sessions }
    });
    refAbonosDialog.afterClosed().subscribe({
      next: (result) => {
        if (result?.data) {
          result?.exit ? this.router.navigate(['/cart-checkout']) : this.buyAbono();
        }
      }
    })
  }

  checkEventHasAbono() {
    const companyId = this.event?.company?.id || this.event?.id_company;
    if (!companyId) return;
    this.bondsService.getBondsByCompany(companyId).subscribe({
      next: (res) => {
        const discounts = (res?.discounts || res?.data || [])
          .filter((d: any) => d.rule_type === 'pass' && d.active);
        if (discounts.length === 0) return;

        forkJoin(
          discounts.map((d: any) =>
            this.bondsService.getPassById(d.id).pipe(
              map((r) => r?.discount || r?.data || r),
              catchError(() => of(null))
            )
          )
        ).subscribe((fullDiscounts: any[]) => {
          const hasAbono = fullDiscounts
            .filter((d) => !!d)
            .some((d: any) =>
              (d.pass_items || []).some((item: any) =>
                (item.event?.id || item.event_id) == this.event.id
              )
            );
          if (hasAbono && !this.endSales) {
            this.enableAbono = true;
          }
        });
      }
    });
  }

  goToScrollPage(idPage: string) {
    var height = document.getElementById(idPage).offsetTop - 30;
    window.scrollTo(0, height);
  }

  openEvent(url: string) {
    if (this.event.external) {
      window.open(url, '_blank');
    } else {
      // Comprobar si es un evento privado
      if (this.event.private_event) {
        const refAbonosDialog = this.dialog.open(PrivateEventComponent, {
          panelClass: ['info-dialog', 'not-padding', 'info-abono-dialog'],
        });
        refAbonosDialog.afterClosed().subscribe({
          next: (result) => {
            if (result) {
              if (result == this.event.private_event_code) {
                this.openHours.emit(true);
              } else {
                const dialogRef = this.dialog.open(InfoCardComponent, {
                  panelClass: 'info-dialog',
                  data: {
                    icon: true,
                    text: 'Lo sentimos, el código es incorrecto.',
                    btnCancel: false
                  }
                });
              }
            }
          }
        })
      } else {
        this.openHours.emit(true);
      }
    }
  }

  convertDateToStringFormat(date: Date, format: string) {
    return (this.eventosService.ConvertDateToStringFormat(date, format));
  }

}
